import { net_filemanage } from "@/api/http";
export const API_STFMFM02C04_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C04/Initialize", ...params)
export const API_STFMFM02C04_Restore = (...params) =>
net_filemanage.post("/api/STFMFM02C04/Restore", ...params)
export const API_STFMFM02C04_Delete= (...params) =>
net_filemanage.post("/api/STFMFM02C04/Delete", ...params)
export const API_STFMFM02C04_SaveFilter= (...params) =>
net_filemanage.post("/api/STFMFM02C04/SaveFilter", ...params)